/**
 * Determines the next active tab UUID when the sidebar selection changes.
 *
 * Rules:
 * - If the current active tab is still selected, keep it.
 * - If the active tab was unchecked:
 *   1. Use the nearest checked item to the LEFT.
 *   2. If nothing to the left, use the nearest checked item to the RIGHT.
 *   3. If nothing at all, return '' (empty state).
 * - If there is no active tab yet (initial selection), return the first selected item.
 */
export function getNextTabValue(
  prev: string,
  collection: Array<{ uuid: string }>,
  selectedCheckboxes: Partial<Record<string, boolean>>
): string {
  if (prev && selectedCheckboxes[prev]) return prev;

  if (prev) {
    const prevIndex = collection.findIndex((c) => c.uuid === prev);
    const leftNeighbor = collection.slice(0, prevIndex).findLast((c) => selectedCheckboxes[c.uuid]);
    if (leftNeighbor) return leftNeighbor.uuid;
    const rightNeighbor = collection.slice(prevIndex + 1).find((c) => selectedCheckboxes[c.uuid]);
    return rightNeighbor?.uuid ?? '';
  }

  return collection.find((c) => selectedCheckboxes[c.uuid])?.uuid ?? '';
}
